export default __webpack_public_path__ + "static/media/2.49964e99.svg";